import React from 'react'
import { Flex, Select } from 'antd'
import Title from 'antd/es/typography/Title'

export default function Selectors ({ boxes, getSlots, setBox }) {
  const boxesOptions = boxes.map((box) => ({ value: box.id, label: box.name }))
  boxesOptions.push({ value: 'all', label: 'Toutes' })

  const periodOptions = [
    { value: 'year', label: 'Année' },
    { value: 'month', label: 'Mois' },
    { value: 'week', label: 'Semaine' }
  ]

  const boxChange = (value) => {
    getSlots(value)
    setBox(boxes.find((b) => b.id === value))
  }

  return (
    <Flex gap='2em'>
      <Flex vertical style={{ width: '20em' }}>
        <Title level={5}>Box</Title>
        <Select options={boxesOptions} defaultValue={'all'} onChange={boxChange} />
      </Flex>
      <Flex vertical style={{ width: '20em' }}>
        <Title level={5}>Période</Title>
        <Select options={periodOptions} defaultValue={'week'}/>
      </Flex>
    </Flex>
  )
}
